import { render, staticRenderFns } from "./yeGiveForm2.vue?vue&type=template&id=c4233fa6&scoped=true"
import script from "./yeGiveForm2.vue?vue&type=script&lang=js"
export * from "./yeGiveForm2.vue?vue&type=script&lang=js"
import style0 from "./yeGiveForm2.vue?vue&type=style&index=0&id=c4233fa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4233fa6",
  null
  
)

export default component.exports